import React, { useEffect, FC, PropsWithChildren } from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";

type ScrollToTopProps = PropsWithChildren<RouteComponentProps>;

const ScrollToTop: FC<ScrollToTopProps> = ({ history, children }: ScrollToTopProps) => {
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });

    return () => {
      unlisten();
    };
  }, [history]);

  return <>{children}</>;
};

export default withRouter(ScrollToTop);
